export default {
  namespaced: true,
  state: () => ({
    unshowArr: [], // 全局不展示列表，有些场景下，部分功能不能使用
  }),
  mutations: {
    vuexSetPrejectUnshow (state, arr) {
      state.unshowArr.push(...arr) // 重复没关系，判断是includes
    }
  },
  actions: {
  },
  getters: {

  }
}
